// WhatsAppShareButton.js
import React from 'react';

const WhatsAppShareButton = ({ message }) => {
  const shareUrl = `https://wa.me/?text=${message}`;

  return (
    <a
      href={shareUrl}
      target="_blank"
      rel="noopener noreferrer"
      className="botao-wpp-HomeIcon"
    >
      <i className="fa fa-whatsapp whatsappIconShare"></i>
    </a>
  );
};

export default WhatsAppShareButton;
